import React from 'react';
import Integrations from './components/Integrations';
import Channel from './components/Channel';
import Application from './components/Application'
import { Redirect, Route, Switch } from 'react-router-dom';

const UI = ({ match }) => (
  <div className="dashboard-wrapper">
    <Switch>
      <Route exact path={`${match.url}`} component={Integrations} />
      <Route path={`${match.url}/channels`} component={Channel} />
      <Route path={`${match.url}/applications`} component={Application} />
      <Redirect to="/error" />
    </Switch>
  </div>
);

export default UI;
